import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolTeachersImproving = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-4 md:col-span-5">
          <Image
            width={250}
            height={250}
            alt="chart"
            className="flex-image"
            src="/images/chart.png"
          />
        </div>
        <div className="col-span-12 lg:col-span-8 md:col-span-7">
          <h2 className="school-section-title h3">
            {t('service.school.certifiedTeachers.explanations.title.quality')}
          </h2>
          <p className="school-section-description">
            {t('service.school.certifiedTeachers.explanations.detail.quality')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolTeachersImproving;
